import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FreteFaixa } from 'src/app/models/frete-faixa';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import swal from 'sweetalert2';

@Component({
  selector: 'app-cadastrar-faixa-frete-modal',
  templateUrl: './cadastrar-faixa-frete-modal.component.html',
  styleUrls: ['./cadastrar-faixa-frete-modal.component.scss']
})
export class CadastrarFaixaFreteModalComponent implements OnInit {
  item: FreteFaixa;
  ultimaFaixa: FreteFaixa;
  itens: FreteFaixa[];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CadastrarFaixaFreteModalComponent>
  ) {
    this.item = this.data.item;

    if (!this.item.ate) {
      this.ultimaFaixa = this.data.ultimaFaixa;
      this.itens = this.data.itens;

      if (this.ultimaFaixa.ate > 0) {
        this.item.de = Number((this.ultimaFaixa.ate + 0.01).toFixed(2));
      } else {
        this.item.de = 0;
      }
    }
  }

  ngOnInit(): void {
  }

  salvar() {
    this.dialogRef.close(this.item);
  }

  fechar() {
    this.dialogRef.close();
  }

}
